import React from 'react';

interface CustomVideoPlayerProps {
  url: string;
  title?: string;
}

const CustomVideoPlayer = ({ url, title }: CustomVideoPlayerProps) => {
  return (
    <div data-wx-video="" onClick={(e) => e.stopPropagation()}>
      <video
        className="video-player"
        preload="metadata"
        controls
        disablePictureInPicture
        controlsList="nodownload noremoteplayback"
        title={title}
      >
        <source src={url} type="video/mp4" />
      </video>
    </div>
  );
};
export default CustomVideoPlayer;
